function buildKlaviyoUpdatedCartPayload(cart) {
  var items = cart.items.map(function (item) {
    return {
      ProductID: item.product_id,
      Name: item.product_title,
      Quantity: item.quantity,
      ItemPrice: item.price / 100,
      RowTotal: item.line_price / 100,
      ProductURL: window.location.origin + item.url,
      ImageURL: item.image,
      Variant: item.variant_title
    };
  });

  return {
    $value: cart.total_price / 100,
    ItemNames: cart.items.map(function (item) {
      return item.product_title;
    }),
    CheckoutURL: window.location.origin + '/cart',
    Items: items
  };
}

function pushKlaviyoUpdatedCart() {
  if (typeof _learnq === 'undefined') return;

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      _learnq.push(['track', 'Updated cart', buildKlaviyoUpdatedCartPayload(cart)]);
    })
    .catch(function () {});
}

['cart:item-added', 'line-item:change:end', 'cart:remove', 'cart:refresh'].forEach(function (eventName) {
  document.addEventListener(eventName, pushKlaviyoUpdatedCart);
});
